import { Taxonomy } from "@common/categories";
import {
    FormRuleActionType,
    TransactionRuleActionFormSchema,
    TransactionRuleConditionFormSchema,
} from "../TransactionRuleForm/constants";

export const TransferRuleFormActions = [
    FormRuleActionType.CATEGORY,
    FormRuleActionType.ACCOUNT_ID,
];

export type TransferMatchingMode = "allow" | "disallow";

export interface TransferRuleFormSchema {
    groupId: string;
    conditions: {
        from: TransactionRuleConditionFormSchema[];
        to: TransactionRuleConditionFormSchema[];
        dateProximity?: number;
    };
    actions: {
        from: TransactionRuleActionFormSchema[];
        to: TransactionRuleActionFormSchema[];
    };
    matchingMode: TransferMatchingMode;
    applyToExistingTransactions: boolean;
    excludedTransactionsIds: number[];
    includedTransactionsIds: number[];
    excludeMatchedTransfers: boolean;
}

export const defaultCategoryTaxonomy = [
    Taxonomy.income,
    Taxonomy.transfer,
    Taxonomy.contributions_distributions,
    Taxonomy.credit_card_loans,

    // Payroll
    Taxonomy.payroll,
];
